import { Inject, NgZone } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogData } from "src/app/header/header.component";

@Component({
	selector: 'app-validation-popup',
	templateUrl: './validation-popup.component.html',
	styleUrls: ['./validation-popup.component.scss']
})
export class ValidationPopupComponent implements OnInit {
	content;
	message;
	elementType;
	showRequiredMessage = false;
	formElements = ["text", "textarea", "email", "phone", "radio", "select", "picture", "file", "question", "contact", "readtext", "address", "date", "time"];
	domElement;
	constructor(
		public dialogRef: MatDialogRef<ValidationPopupComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private ngZone: NgZone
	) { }

	ngOnInit() {
		this.ngZone.run(() => {
			this.showRequiredMessage = false
			if(this.data['content'] && typeof this.data['content'] != "string") {
				this.domElement = this.data['content']['domElement'];
				this.message = this.data['content']['message'];
				this.content = this.data['content']['content'];
				if(this.data['content']['element'] && this.data['content']['element']['key'] && (this.data['content']['element']['key'] != "employeename")) {
					let element = this.data['content']['element']['type'] ? this.data['content']['element']['type'] : ""
					this.showRequiredMessage = this.formElements.indexOf(element) > -1 ? true : false
				}			
			} else {
				this.content = this.data['content']
			}
		})
	}

	onNoClick(): void {
		this.ngZone.run(() => {
			this.dialogRef.close({element: this.domElement});
		})
	}

}
